export enum ActivityLogTypes {
    USER_INVITATION = 'USER_INVITATION',
    USER = 'USER',
    RELYING_PARTY = 'RELYING_PARTY',
    ORGANIZATION = 'ORGANIZATION',
    RPSERVICE = 'RPSERVICE',
    WORKFLOW = 'WORKFLOW'
}